// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import '../web/jquery.gm';

export default class GoogleMap extends WebComponent {
    didMount() {
        const {
            url,
        } = this.props;

        const $map = $(this.element);

        window.web = window.web || {};
        var web = window.web;

        web.googlemaps = web.googlemaps || {};
        web.googlemaps.activeMarker = null;

        // listeners on google markers
        web.googlemaps.loadMarkersListeners = {
            click: function(e, data, marker) {
                var $card = $('.map-card');

                // clicking on inactive marker
                if (marker.opened) {

                    web.googlemaps.activeMarker = web.googlemaps.setMarkerIcon(marker, false);
                    web.googlemaps.activeMarker = null;
                    marker.opened = false;
                    $card.empty().hide().removeClass('active');

                } else {

                    // inactivate previously activated marker
                    if (web.googlemaps.activeMarker && web.googlemaps.activeMarker.opened) {
                        web.googlemaps.activeMarker.opened = false;
                        web.googlemaps.activeMarker = web.googlemaps.setMarkerIcon(web.googlemaps.activeMarker, false);
                        web.googlemaps.activeMarker = null;
                    }

                    // set current marker active
                    web.googlemaps.activeMarker = web.googlemaps.setMarkerIcon(marker, true);
                    web.googlemaps.activeMarker = marker;
                    marker.opened = true;

                    // render custom bubble
                    $card.html(web.googlemaps.createCard(data)).show().addClass('active');
                }
            }
        };

        // set activity color of the marker
        web.googlemaps.setMarkerIcon = function(marker, active) {
            if (active) {
                marker.originalData = {
                    x: marker.getIcon().origin.x,
                    y: marker.getIcon().origin.y,
                    url: marker.getIcon().url,
                    size: marker.getIcon().size,
                    anchor: marker.getIcon().anchor,
                    shape: marker.getIcon().shape
                }
            }
            var iconProperties = {
                icon: {
                    origin: active ? new google.maps.Point(0, marker.originalData.y - 76) : new google.maps.Point(marker.originalData.x, marker.originalData.y),
                    url: marker.originalData.url,
                    size: active ? new google.maps.Size(62, 62) : marker.originalData.size,
                    anchor: active ? new google.maps.Point(31, 31) : marker.originalData.anchor
                },
                shape: active ? {
                    coords					:		[31,31,31],
                    type					:		'circle'
                } : marker.originalData.shape
            };

            marker.setOptions(iconProperties);

            return active ? marker : null;
        };

        // create googlemap card
        web.googlemaps.createCard = function(data) {
            var str = '';
            str += '<div class="map-card__motive">';

            if (data.motive && data.motive != "") {
				str += '<img src="'+data.motive+'" alt="">';
                if (data.swLink && data.swLink != "") {
                    str += '<a href="'+data.swLink+'" target="_blank" rel="noopener noreferrer" class="btn btn--small">Street view</a>';
                }
            }

            str += '</div>';
            str += '<div class="map-card__content">';
			str += '<h4 class="map-card__title">'+data.title+'</h4>';
            if (data.address && data.address != "") {
                str += '<p>' + data.address + '</p>';
            }
            if (data.openingHours && data.openingHours != "") {
                str +='<p>'+web.googlemaps.getText(($("html").attr("lang") || "cs"),"openingHours")+': '+data.openingHours+'</p>';
            }
            if (data.phone1 && data.phone1 != "") {
                str +='<p>'+web.googlemaps.getText(($("html").attr("lang") || "cs"),"reception")+': '+data.phone1+'</p>';
            }
            if (data.phone2 && data.phone2 != "") {
                str +='<p>'+web.googlemaps.getText(($("html").attr("lang") || "cs"),"buildingManager")+': '+data.phone2+'</p>';
            }
            if (data.detailLink && data.detailLink != "") {
                str += '<a class="btn-arrow btn--block" href="'+data.detailLink+'">Detail<svg class="svg-icon"  ><use xlink:href="#arrow-right"></use></svg></a>';
            }
            str += '</div>';
            return str;
        };

        web.googlemaps.getText = function(lang, textId){
            var structure = {
                "cs": {
                    "openingHours": "Otevírací doba",
                    "reception": "Recepce",
                    "buildingManager": "Správce budovy"
                },
                "en": {
                    "openingHours": "Opening hours",
                    "reception": "Reception",
                    "buildingManager": "Building manager"
                }
            };

            return structure[lang][textId];
        };

        /**
         * googlemap base setup
         */
        $.googlemap.setDefaults({
            mapOptions: {
                startingPosition: {
                    lat:  50.209271199417586,
                    lng:  15.832800975675456,
                    zoom: 13
                },
                minZoom: 3,
                mapTypeControl:    false,
                scaleControl:      false,
                panControl:        true,
                streetViewControl: false,
                zoomControl:       true,
                scrollwheel:       false
            },
            markerTypes: [
                // default marker, empty
                {},
                {
                    icon						:	{
                        url: '/img/u/markers.png?v02',
                        size: new google.maps.Size(33,33),
                        origin: new google.maps.Point(14,76),
                        anchor: new google.maps.Point(16,16)
                    },
                    shape						:	{
                        coords					:		[16,16,16],
                        type					:		'circle'
                    }
                },
                {
                    icon						:	{
                        url: '/img/u/markers.png?v02',
                        size: new google.maps.Size(33,33),
                        origin: new google.maps.Point(14,200),
                        anchor: new google.maps.Point(16,16)
                    },
                    shape						:	{
                        coords					:		[16,16,16],
                        type					:		'circle'
                    }
                },
                {
                    icon						:	{
                        url: '/img/u/markers.png?v02',
                        size: new google.maps.Size(33,33),
                        origin: new google.maps.Point(14,324),
                        anchor: new google.maps.Point(16,16)
                    },
                    shape						:	{
                        coords					:		[16,16,16],
                        type					:		'circle'
                    }
                },
                {
                    icon						:	{
                        url: '/img/u/markers.png?v02',
                        size: new google.maps.Size(33,33),
                        origin: new google.maps.Point(14,448),
                        anchor: new google.maps.Point(16,16)
                    },
                    shape						:	{
                        coords					:		[16,16,16],
                        type					:		'circle'
                    }
                },
                {
                    icon						:	{
                        url: '/img/u/markers.png?v02',
                        size: new google.maps.Size(33,33),
                        origin: new google.maps.Point(14,572),
                        anchor: new google.maps.Point(16,16)
                    },
                    shape						:	{
                        coords					:		[16,16,16],
                        type					:		'circle'
                    }
                },
                {
                    icon						:	{
                        url: '/img/u/markers.png?v02',
                        size: new google.maps.Size(33,33),
                        origin: new google.maps.Point(14,696),
                        anchor: new google.maps.Point(16,16)
                    },
                    shape						:	{
                        coords					:		[16,16,16],
                        type					:		'circle'
                    }
                },
                {
                    icon						:	{
                        url: '/img/u/markers.png?v02',
                        size: new google.maps.Size(33,33),
                        origin: new google.maps.Point(14,820),
                        anchor: new google.maps.Point(16,16)
                    },
                    shape						:	{
                        coords					:		[16,16,16],
                        type					:		'circle'
                    }
                },
                {
                    icon						:	{
                        url: '/img/u/markers.png?v02',
                        size: new google.maps.Size(33,33),
                        origin: new google.maps.Point(14,944),
                        anchor: new google.maps.Point(16,16)
                    },
                    shape						:	{
                        coords					:		[16,16,16],
                        type					:		'circle'
                    }
                },
                {
                    icon						:	{
                        url: '/img/u/markers.png?v02',
                        size: new google.maps.Size(33,33),
                        origin: new google.maps.Point(14,1068),
                        anchor: new google.maps.Point(16,16)
                    },
                    shape						:	{
                        coords					:		[16,16,16],
                        type					:		'circle'
                    }
                },
                {
                    icon						:	{
                        url: '/img/u/markers.png?v02',
                        size: new google.maps.Size(33,33),
                        origin: new google.maps.Point(14,1192),
                        anchor: new google.maps.Point(16,16)
                    },
                    shape						:	{
                        coords					:		[16,16,16],
                        type					:		'circle'
                    }
                },
                {
                    icon						:	{
                        url: '/img/u/markers.png?v02',
                        size: new google.maps.Size(33,33),
                        origin: new google.maps.Point(14,1316),
                        anchor: new google.maps.Point(16,16)
                    },
                    shape						:	{
                        coords					:		[16,16,16],
                        type					:		'circle'
                    }
                }
            ]
        });

        $map.googlemap();

        $map.googlemap('loadMarkers', {
            dataUrl: url,
            dataSetName: 'data',
            disableInfowindow: true,
            listeners: web.googlemaps.loadMarkersListeners || null
        });

        window.google.maps._$map = $map;
    }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/GoogleMap.js